import { sessionStorageKeys, STORAGE } from 'config/storage-config';
import { checkMatchPath } from 'utils/misc';
import { PARTNERS } from 'config/app-config';

export const getSessionStoragePartner = () =>
  STORAGE.getItem(sessionStorageKeys.PARTNER_PATH);

export const findPartnerLanding = ({ pathname, search }) => {
  const currentPath =
    pathname?.replace(import.meta.env.VITE_PATH_PREFIX!, '') || '/';
  const partnerLandingPaths = Object.values(PARTNERS);
  const matchesQuery = partnerLandingPaths.some((partner) =>
    checkMatchPath(currentPath + search, partner)
  );
  const matchesPath = partnerLandingPaths.some((partner) =>
    checkMatchPath(currentPath, partner)
  );

  switch (true) {
    case matchesQuery:
      return currentPath + search;
    case matchesPath:
      return currentPath;
    default:
      return null;
  }
};

export const getJourneyName = () => {
  /* istanbul ignore next -- @preserve */
  const partnerLanding =
    findPartnerLanding(window.location) || getSessionStoragePartner();
  const journey = Object.entries(PARTNERS).find(([, value]) => {
    return checkMatchPath(partnerLanding, value);
  })?.[0];

  return journey;
};
